import {GridLoader} from 'react-spinners';
import React from 'react';

export default props => {

  return (
    <div className="spinner-item">
      <GridLoader loading={props.loading}/>
    </div>
  );
}
